/** Metronome click: short sine blip, higher on the accented downbeat. */
export function scheduleClick(ctx: BaseAudioContext, destination: AudioNode, timeSec: number, accent: boolean): void {
  const o = ctx.createOscillator();
  o.frequency.value = accent ? 2000 : 1400;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, timeSec);
  g.gain.exponentialRampToValueAtTime(accent ? 0.6 : 0.4, timeSec + 0.001);
  g.gain.exponentialRampToValueAtTime(0.0001, timeSec + 0.04);
  o.connect(g).connect(destination);
  o.start(timeSec);
  o.stop(timeSec + 0.05);
  o.onended = () => { o.disconnect(); g.disconnect(); };
}
